import React, { useContext, useEffect } from "react";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import BryntumContext from "../../context/bryntumContext.jsx";
import AuthContext from "../../context/authContext.jsx";
import { ImportEditor } from "../../../modern/components/editors/importEditor/ImportEditor";
import { UserEditor } from "../../../modern/components/editors/userEditor/UserEditor";
import { EntityFinderEditor } from "../../../modern/components/editors/entityFinder/EntityFinderEditor";
import { EntityTagEditor } from "../../../modern/components/editors/entityTagEditor/EntityTagEditor";
import { ViewOrganizerEditor } from "../../../modern/components/editors/viewOrganizerEditor/ViewOrganizerEditor";
import { BoardAlertsEditor } from "../../../modern/components/editors/boardAlerts/BoardAlertsEditor";
import { BudgetEditor } from "../../../modern/components/editors/budget/BudgetEditor";
import SwivuAsyncMessageModal from "../../../bryntum-lib/editors/AsyncTaskMessageEditor/SwivuAsyncMessagePopup.jsx";
import { SwivuAssistEditor } from "../../../modern/components/editors/swivuAssist/SwivuAssistEditor";
import { OutcomeIncentiveEditor } from "./incentive/outcome/OutcomeIncentiveEditor.jsx";
import { SpotIncentiveEditor } from "./incentive/spotIncentive/SpotIncentiveEditor.jsx";
import { SwivuPointsLeaderboardPopup } from "./pointsLeaderboard/SwivuPointsLeaderboardPopup.jsx";
import { AwardTagEditor } from "../../../modern/components/editors/awardTagEditor/AwardTagEditor";
import { TaskGeneralEditor } from "../entityViews/general/editors/TaskGeneralEditor";
import { ResourceGeneralEditor } from "../entityViews/general/editors/ResourceGeneralEditor";
import SwivuTaskFilesEditorPopup from "../../../bryntum-lib/editors/taskFilesEditor/SwivuTaskFilesEditor";
import { TaskFinderEditor } from "../../../modern/components/editors/taskFinder/TaskFinderEditor";
import { ClientGeneralEditor } from "../entityViews/general/editors/ClientGeneralEditor";
import { SwivuChecklistEditorPopup } from "../entityViews/checklist/components/editors/ChecklistEditor";
import SwivuContactEditorPopup from "../../../bryntum-lib/editors/contactEditor/SwivuContactEditor";
import { DuplicateBoardEditor } from "../../../modern/components/editors/duplicateBoardEditor/DuplicateBoardEditor";
import { MyMediaPopup } from "../../../modern/components/editors/myMediaPopup/MyMediaPopup";
import { SwivuNotesEditor } from "../entityViews/notes/components/editors/NotesEditor";
import { ViewEditor } from "@/modern/components/editors/viewEditor/ViewEditor";

// Whatever key added into EditorsKey should have relevant component being attached here
const Editors = {
  [EDITOR_KEYS.taskEditor]: TaskGeneralEditor,
  [EDITOR_KEYS.resourceEditorV2]: ResourceGeneralEditor,
  [EDITOR_KEYS.clientEditorV2]: ClientGeneralEditor,
  [EDITOR_KEYS.importEditor]: ImportEditor,

  [EDITOR_KEYS.userEditor]: UserEditor,
  [EDITOR_KEYS.contactEditor]: SwivuContactEditorPopup,
  [EDITOR_KEYS.viewOrganizerEditor]: ViewOrganizerEditor,
  // Not being used
  [EDITOR_KEYS.entityFinder]: EntityFinderEditor,
  [EDITOR_KEYS.entityTagEditor]: EntityTagEditor,
  [EDITOR_KEYS.boardAlertEditor]: BoardAlertsEditor,

  [EDITOR_KEYS.budgetEditor]: BudgetEditor,
  [EDITOR_KEYS.viewInspectorEditor]: ViewEditor,
  [EDITOR_KEYS.asyncTaskMessageEditor]: SwivuAsyncMessageModal,
  [EDITOR_KEYS.outcomeIncentiveEditor]: OutcomeIncentiveEditor,
  [EDITOR_KEYS.spotIncentiveEditor]: SpotIncentiveEditor,
  [EDITOR_KEYS.pointsLeaderboardPopup]: SwivuPointsLeaderboardPopup,
  [EDITOR_KEYS.awardTagEditor]: AwardTagEditor,
  [EDITOR_KEYS.taskFilesEditor]: SwivuTaskFilesEditorPopup,
  [EDITOR_KEYS.taskFinderEditor]: TaskFinderEditor,
  [EDITOR_KEYS.swivuAssistEditor]: SwivuAssistEditor,
  [EDITOR_KEYS.checklistEditor]: SwivuChecklistEditorPopup,
  [EDITOR_KEYS.duplicateBoardEditor]: DuplicateBoardEditor,
  [EDITOR_KEYS.myMediaEditor]: MyMediaPopup,
  [EDITOR_KEYS.noteEditor]: SwivuNotesEditor,
}

const getEditorByType = ({ type }) => {
  const EditorComp = Editors[type];
  if (EditorComp) return EditorComp;
  throw new Error(`The editor "${type}" does not exists`);
};

const EditorViews = () => {
  const context = useContext(BryntumContext);
  const { user } = useContext(AuthContext);
  const { getEditors, closeEditor, closeAllEditors } = context.editorHandler;
  const editors = getEditors();

  useEffect(() => {
    if (!user) closeAllEditors();
  }, [closeAllEditors, user]);
  return (
    <>
      {editors && context?.user &&
        editors.map((editor) => {
          const Editor = getEditorByType(editor);
          return (
            <Editor
              key={editor.id}
              isShow
              context={context}
              record={editor.record}
              onClose={() => closeEditor(editor)}
              editorInstance={editor}
            />
          );
        })}
    </>
  );
};

export default EditorViews;
